import { render } from "./person-legal-detail.vue?vue&type=template&id=e59b73dc"
import script from "./person-legal-detail.vue?vue&type=script&lang=js"
export * from "./person-legal-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__